import { render, staticRenderFns } from "./countryregion-edit.vue?vue&type=template&id=af6bb0fe&"
import script from "./countryregion-edit.vue?vue&type=script&lang=js&"
export * from "./countryregion-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports